import { Component, OnInit, Inject, NgZone } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';
import { startWith, debounceTime, distinctUntilChanged, switchMap, map } from 'rxjs/operators';
import { MatSelectChange } from '@angular/material/select';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
    selector: 'md-agent-planner-agents-picker-dialog',
    templateUrl: './md-agent-planner-agents-picker-dialog.component.html',
})
export class MDAgentPlannerAgentsPickerDialog implements OnInit {
    searchFormControl = new FormControl('');
    dataSource: MatTableDataSource<any>;
    selection = new SelectionModel<any>(true, []);
    agents: any[] = [];
    displayedColumns: string[] = ['select', 'FULLNAME'];


    constructor(
        public dialogRef: MatDialogRef<MDAgentPlannerAgentsPickerDialog>,
        @Inject(MAT_DIALOG_DATA) private data: { agents: any[], selectedAgentsIds: string[] },
    ) {
        this.agents = data.agents;
        this.dataSource = new MatTableDataSource(this.agents);
        this.selection.select(...this.agents.filter(agent => data.selectedAgentsIds.includes(agent.ID)).map(agent => agent.ID));
    }

    ngOnInit() {
    }

    dismiss() {
        this.dialogRef.close();
    }

    onSubmit() {
        this.dialogRef.close(this.selection.selected.map(agent => agent));
    }

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.agents.length;
        return numSelected === numRows;
    }

    toggleAllRows() {
        if (this.isAllSelected()) {
            this.selection.clear();
            return;
        }

        this.selection.select(...this.agents.map(agent => agent.ID));
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }
}